export const translations = {
  en: {
    // Navigation
    episodes: 'Episodes',
    saves: 'Saves',
    settings: 'Settings',
    messages: 'Messages',
    gallery: 'Gallery',
    exit: 'Exit',

    // Settings
    language: 'Language',
    sound: 'Sound',
    vibration: 'Vibration',
    showClock: 'Show Clock',
    messageSpeed: 'Message Speed',
    version: 'Version',
    langAuto: 'Auto',
    langEn: 'English',
    langRu: 'Russian',

    // Saves
    renameSave: 'Rename Save',
    loadSave: 'Load Save',
    resetProgress: 'Reset Progress',
    resetConfirm: 'Are you sure you want to reset all progress? This action cannot be undone.',
    loadConfirm: 'Load "{name}"? Current unsaved progress will be lost.',
    cancel: 'Cancel',
    save: 'Save',
    load: 'Load',
    resetAll: 'Reset All',
    loadingSaves: 'Loading saves...',
    reset: 'Reset',
    noSaves: 'No saves yet',
    autoSave: 'Auto',
    saveSlot: 'Slot',

    // Exit
    leaveGame: 'Leave the game?',
    progressSaved: 'Your progress has been saved',
    stay: 'Stay',

    // Patreon / Itch (brand names stay English)
    subscribePatreon: 'Subscribe on Patreon to unlock perks',
    linkPatreon: 'Link your Patreon',
    goToPatreon: 'Go to Patreon',
    linkPatreonGallery: 'Link your Patreon account to unlock the full gallery',
    comingSoon: 'Updates are released on Patreon first.',

    // Story graph
    viewStoryGraph: 'View Story Graph',
    storyGraphWarning: 'This will show the full story graph. Spoiler alert!',
    show: 'Show',

    // Misc
    chapter: 'Chapter',
    backstory: 'Backstory',
    statistics: 'Statistics',
    playTime: 'Play time',
    relationship: 'Relationship',
    newContact: 'New contact added',

    // Saves screen
    currentProgress: 'Current Progress',
    empty: 'Empty',
    inProgress: 'In progress',
    playing: 'Playing',
    playtime: 'Playtime',

    // Gallery
    setAsWallpaper: 'Set as Wallpaper',
    noPhotosYet: 'No photos yet',
    premiumContent: 'Premium Content',
    fullGallery: 'Full Gallery',
    crossSave: 'Cross-Save',
    photosUnlocked: 'Photos Unlocked',

    // Contacts
    contacts: 'Contacts',
    contact: 'Contact',

    // Music / Sextify
    nowPlaying: 'Now Playing',
    queue: 'Queue',
    tracks: 'tracks',
    noMusicYet: 'No music available yet',
    unlockCovers: 'Complete Chapter 10 once to unlock covers',

    // Patreon
    supportProject: 'Support the project',
    supportDesc: 'Unlock premium content and help us create more stories',
    currentMembership: 'Current Membership',
    freeTier: 'Free',
    getMembership: 'Get Membership',

    // Chapters / Episodes
    noChaptersYet: 'No chapters yet',
    continueBtn: 'Continue',

    // Results
    results: 'Results',
    timePlayed: 'Time Played',
    mediaUnlocked: 'Media Unlocked',

    // Story graph
    storyGraphLogOnly: "You'll see only your own playthrough log.",
    andAbove: 'and above',
    storyGraphSpoilers: 'Viewing unexplored branches and spoilers is available with the {tier} tier and above.',
    viewLog: 'View log',

    // Coming soon
    comingSoonTitle: 'Coming Soon',
    comingSoonBody: 'This content is not available yet. Stay tuned for updates!',
    newGame: 'New Game',

    // Patreon benefits
    connectAccount: 'Connect your account to activate perks',
    benefitEarlyAccess: 'Early access to new chapters',
    benefitExclusive: 'Exclusive story arcs & scenarios',
    benefitGallery: 'Full gallery unlock',

    // Patreon linking button states
    checking: 'Checking…',
    linked: 'Linked',
    authOpened: 'Finish in browser, then tap again',
    tapToRefresh: 'Tap to refresh · × to log out',

    // Statistics
    currentSave: 'Current save',
    allSaves: 'All Saves',
    photos: 'Photos',
    videos: 'Videos',

    // Restore progress (in Saves screen)
    savesRestore: 'Restore progress',
    savesRestoreHint: 'Continue from a chapter you played in an older version',
    quizRestoreTitle: 'Restore progress',
    quizPickChapterHint: 'Pick the chapter you want to start from. We\'ll ask about your past decisions so the next chapter plays out the way you remember.',
    quizNoChaptersAvailable: 'No chapters available to restore yet.',
    quizBack: 'Back',
    quizRestoring: 'Preparing your story…',
    loadingRestoreHint: 'Tip: you can also restore an older playthrough in the Saves screen.',

    // Timeskip labels
    momentLater: 'A moment later',
    fewMinLater: 'A few minutes later',
    min5Later: '5 minutes later',
    min10Later: '10 minutes later',
    aboutMin10Later: 'About 10 minutes later',
    min15Later: '15 minutes later',
    aboutMin15Later: 'About 15 minutes later',
    min20Later: '20 minutes later',
    aboutMin20Later: 'About 20 minutes later',
    halfHourLater: 'Half an hour later',
    aboutHourLater: 'About an hour later',
    hourLater: 'An hour later',
    coupleHoursLater: 'A couple of hours later',
    severalHoursLater: 'Several hours later',
    nextMorning: 'Next morning',
    thatAfternoon: 'That afternoon',
    thatEvening: 'That evening',
    laterThatNight: 'Later that night',
  },
  ru: {
    // Navigation
    episodes: 'Эпизоды',
    saves: 'Сохранения',
    settings: 'Настройки',
    messages: 'Сообщения',
    gallery: 'Галерея',
    exit: 'Выход',

    // Settings
    language: 'Язык',
    sound: 'Звук',
    vibration: 'Вибрация',
    showClock: 'Часы',
    messageSpeed: 'Скорость сообщений',
    version: 'Версия',
    langAuto: 'Авто',
    langEn: 'English',
    langRu: 'Русский',

    // Saves
    renameSave: 'Переименовать',
    loadSave: 'Загрузить сохранение',
    resetProgress: 'Сброс прогресса',
    resetConfirm: 'Вы уверены, что хотите сбросить весь прогресс? Это действие нельзя отменить.',
    loadConfirm: 'Загрузить "{name}"? Текущий несохранённый прогресс будет потерян.',
    cancel: 'Отмена',
    save: 'Сохранить',
    load: 'Загрузить',
    resetAll: 'Сбросить всё',
    loadingSaves: 'Загрузка сохранений...',
    reset: 'Сброс',
    noSaves: 'Нет сохранений',
    autoSave: 'Авто',
    saveSlot: 'Слот',

    // Exit
    leaveGame: 'Покинуть игру?',
    progressSaved: 'Ваш прогресс сохранён',
    stay: 'Остаться',

    // Patreon / Itch (brand names stay as-is)
    subscribePatreon: 'Стань патроном для разблокировки бонусов',
    linkPatreon: 'Привязать Patreon',
    goToPatreon: 'Перейти на Patreon',
    linkPatreonGallery: 'Привяжите аккаунт Patreon для доступа к полной галерее',
    comingSoon: 'Обновления выходят на Patreon раньше.',

    // Story graph
    viewStoryGraph: 'Граф истории',
    storyGraphWarning: 'Будет показан полный граф истории. Осторожно, спойлеры!',
    show: 'Показать',

    // Misc
    chapter: 'Глава',
    backstory: 'Предыстория',
    statistics: 'Статистика',
    playTime: 'Время игры',
    relationship: 'Отношения',
    newContact: 'Новый контакт добавлен',

    // Saves screen
    currentProgress: 'Текущий прогресс',
    empty: 'Пусто',
    inProgress: 'В процессе',
    playing: 'Играет',
    playtime: 'Время игры',

    // Gallery
    setAsWallpaper: 'Установить как обои',
    noPhotosYet: 'Пока нет фото',
    premiumContent: 'Премиум контент',
    fullGallery: 'Полная галерея',
    crossSave: 'Кросс-сейв',
    photosUnlocked: 'Фото разблокировано',

    // Contacts
    contacts: 'Контакты',
    contact: 'Контакт',

    // Music / Sextify
    nowPlaying: 'Сейчас играет',
    queue: 'Очередь',
    tracks: 'треков',
    noMusicYet: 'Музыка пока недоступна',
    unlockCovers: 'Пройдите главу 10 для разблокировки обложек',

    // Patreon
    supportProject: 'Поддержать проект',
    supportDesc: 'Разблокируйте премиум-контент и помогите нам создавать новые истории',
    currentMembership: 'Текущая подписка',
    freeTier: 'Free',
    getMembership: 'Получить подписку',

    // Chapters / Episodes
    noChaptersYet: 'Пока нет глав',
    continueBtn: 'Продолжить',

    // Results
    results: 'Результаты',
    timePlayed: 'Время игры',
    mediaUnlocked: 'Медиа разблокировано',

    // Story graph
    storyGraphLogOnly: 'Вы увидите только свой лог прохождения.',
    andAbove: 'и выше',
    storyGraphSpoilers: 'Просмотр неисследованных веток и спойлеров доступен с подпиской {tier} и выше.',
    viewLog: 'Смотреть лог',

    // Coming soon
    comingSoonTitle: 'Скоро',
    comingSoonBody: 'Этот контент ещё не доступен. Следите за обновлениями!',
    newGame: 'Новая игра',

    // Timeskip labels
    // Patreon benefits
    connectAccount: 'Подключите аккаунт для активации бонусов',
    benefitEarlyAccess: 'Ранний доступ к новым главам',
    benefitExclusive: 'Эксклюзивные сюжетные арки и сценарии',
    benefitGallery: 'Полная разблокировка галереи',

    // Patreon linking button states
    checking: 'Проверяем…',
    linked: 'Привязано',
    authOpened: 'Авторизуйтесь в браузере, затем нажмите снова',
    tapToRefresh: 'Нажмите для обновления · × чтобы выйти',

    // Statistics
    currentSave: 'Текущий прогресс',
    allSaves: 'Все сохранения',
    photos: 'Фото',
    videos: 'Видео',

    // Restore progress (in Saves screen)
    savesRestore: 'Восстановить прогресс',
    savesRestoreHint: 'Продолжите с главы, которую проходили в старой версии',
    quizRestoreTitle: 'Восстановление прогресса',
    quizPickChapterHint: 'Выберите главу, с которой хотите продолжить. Мы зададим несколько вопросов о прошлых решениях, чтобы следующая глава играла так, как вы помните.',
    quizNoChaptersAvailable: 'Пока нет глав, доступных для восстановления.',
    quizBack: 'Назад',
    quizRestoring: 'Готовим вашу историю…',
    loadingRestoreHint: 'Совет: восстановить старое прохождение можно в окне Saves.',

    momentLater: 'Мгновение спустя',
    fewMinLater: 'Несколько минут спустя',
    min5Later: '5 минут спустя',
    min10Later: '10 минут спустя',
    aboutMin10Later: 'Около 10 минут спустя',
    min15Later: '15 минут спустя',
    aboutMin15Later: 'Около 15 минут спустя',
    min20Later: '20 минут спустя',
    aboutMin20Later: 'Около 20 минут спустя',
    halfHourLater: 'Полчаса спустя',
    aboutHourLater: 'Около часа спустя',
    hourLater: 'Час спустя',
    coupleHoursLater: 'Пару часов спустя',
    severalHoursLater: 'Несколько часов спустя',
    nextMorning: 'На следующее утро',
    thatAfternoon: 'Днём',
    thatEvening: 'Вечером',
    laterThatNight: 'Позже ночью',
  }
};

/**
 * Resolve 'auto' language to actual language code based on browser locale.
 * @param {string} lang - 'auto' | 'en' | 'ru'
 * @returns {'en' | 'ru'}
 */
export function resolveLanguage(lang) {
  if (lang === 'auto') {
    return (navigator.language || '').startsWith('ru') ? 'ru' : 'en';
  }
  return lang === 'ru' ? 'ru' : 'en';
}

/**
 * Create a translation function for the given language.
 * @param {'en' | 'ru'} lang
 * @returns {(key: string, params?: Record<string, string>) => string}
 */
export function createT(lang) {
  const dict = translations[lang] || translations.en;
  const fallback = translations.en;
  return (key, params) => {
    let str = dict[key] || fallback[key] || key;
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        str = str.replace(`{${k}}`, v);
      }
    }
    return str;
  };
}
